import { CheckCircle2, Globe2, ShieldCheck } from "lucide-react";
import shonanLogo from "@/assets/shonan-palm-gold-transparent.png";
import expresswayLightTrails from "@/assets/japan-expressway-light-trails.png";
import { useLanguage } from "@/contexts/LanguageContext";

export default function AuthShell({
  brandLogo = shonanLogo,
  children,
  eyebrow,
  title,
  subtitle,
  languageSelector,
}) {
  const { language, t } = useLanguage();
  const titleLines = String(title || "").split("\n");
  const languageClassName = `auth-lang-${language}`;
  const titleClassName = `auth-brand-title ${language === "en" ? "auth-brand-title-en" : ""} ${language === "ja" ? "auth-brand-title-ja" : ""}`;
  const mobileTitleClassName = `auth-mobile-title ${language === "en" ? "auth-mobile-title-en" : ""} ${language === "ja" ? "auth-mobile-title-ja" : ""}`;

  return (
    <div className={`auth-shell ${languageClassName}`}>
      <img
        src={expresswayLightTrails}
        alt=""
        aria-hidden="true"
        className="auth-background-image"
      />
      <section className="auth-brand-panel" aria-label="Shonan International">
        <div className="auth-logo-stack">
          <div className="auth-brand-mark">
            <img src={brandLogo} alt={eyebrow || "Shonan International"} />
          </div>
          <p className="auth-eyebrow">{eyebrow}</p>
          <p className="auth-logo-caption">{t('authLogoCaption')}</p>
        </div>

        <div className="auth-brand-copy">
          <h1 className={titleClassName}>
            {titleLines.map((line, index) => (
              <span key={`${line}-${index}`}>{line}</span>
            ))}
          </h1>
          <p className="auth-brand-subtitle">{subtitle}</p>
          <p className="auth-trust-line">{t('authTrustedTagline')}</p>
        </div>

        <div className="auth-feature-grid">
          <div className="auth-feature">
            <ShieldCheck className="h-5 w-5" />
            <div>
              <strong>{t('authFeatureQualityTitle')}</strong>
              <p>{t('authFeatureQualityDesc')}</p>
            </div>
          </div>
          <div className="auth-feature">
            <Globe2 className="h-5 w-5" />
            <div>
              <strong>{t('authFeatureLanguagesTitle')}</strong>
              <p>{t('authFeatureLanguagesDesc')}</p>
            </div>
          </div>
          <div className="auth-feature">
            <CheckCircle2 className="h-5 w-5" />
            <div>
              <strong>{t('authFeatureBookingTitle')}</strong>
              <p>{t('authFeatureBookingDesc')}</p>
            </div>
          </div>
        </div>
      </section>

      <section className="auth-form-panel">
        <div className="auth-mobile-brand">
          <div className="auth-mobile-logo">
            <img src={brandLogo} alt={eyebrow || "Shonan International"} />
          </div>
          <p className="auth-mobile-eyebrow">{eyebrow}</p>
          <h1 className={mobileTitleClassName}>
            {titleLines.map((line, index) => (
              <span key={`${line}-${index}`}>{line}</span>
            ))}
          </h1>
          <p className="auth-mobile-subtitle">{subtitle}</p>
          <p className="auth-mobile-trust-line">{t('authTrustedTagline')}</p>
        </div>
        <div className="auth-language-wrap">{languageSelector}</div>
        {children}
      </section>
    </div>
  );
}
